import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useWaitingSignal } from '../../hooks/useWaitingSignal';
import { ageText, livenessOf } from '../../lib/workQueue/waitingSignal';

/**
 * The cockpit says how fresh it is, so Gilles no longer reloads to know whether he is up to date
 * (01/10/2026): « En direct » (green, breathing) while the server can reach the page; « À jour ·
 * il y a 8 s » while it follows by reading, the channel being down; amber « Dernière vérification
 * il y a 2 min » once reads fail too — the list may then be behind.
 */
export function LiveMark() {
  const signal = useWaitingSignal();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 5_000);
    return () => window.clearInterval(id);
  }, []);

  const live = livenessOf(signal, Math.max(now, signal.checkedAt ?? 0));
  if (live.kind === 'pending') return null;
  const stale = live.kind === 'stale';
  const text =
    live.kind === 'live'
      ? 'En direct'
      : live.kind === 'polling'
        ? `À jour · ${ageText(live.ageMs)}`
        : `Dernière vérification ${ageText(live.ageMs)}`;
  return (
    <span
      className={twMerge(
        'flex items-center gap-1.5 text-xs',
        stale ? 'text-desk-soft' : 'text-desk-muted',
      )}
      title={live.kind === 'live' ? 'Le serveur prévient la page dès que quelque chose bouge' : 'Connexion directe indisponible : la page vérifie toutes les 15 s'}
      role="status"
    >
      <span
        aria-hidden="true"
        className={twMerge(
          'h-1.5 w-1.5 rounded-full',
          stale ? 'bg-desk-signal' : 'bg-desk-accent',
        )}
      />
      {text}
    </span>
  );
}
